const HOST = process.env.REACT_APP_API_URL || "http://api.jaroplayer.com/";
const RESELLER_HOST = process.env.REACT_APP_RESELLER_URL || "http://reseller.jaroplayer.com/";
const API_HOST = `${HOST}api/`;
export { API_HOST, HOST, RESELLER_HOST, };
